export default __webpack_public_path__ + "static/media/ee6.a04595aa.png";